import { Button } from 'uikit'
import { useState } from 'react'

export const ActionButton = ({ onClick, children, ...props }) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async (e) => {
    try {
      e.stopPropagation()
      e.preventDefault()
      setIsLoading(true)
      await onClick()
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Button size="sm" loading={isLoading} onClick={handleClick} {...props}>
      {children}
    </Button>
  )
}
